import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/StudentDocument/SearchWithPaging",
    method: "get",
    params
  });
}
export function syncDPSI(data) {
  return request({
    url: "/StudentDocument/SyncDPSI",
    method: "post",
    data
  });
}
export function updInfo(data) {
  return request({
    url: "/StudentDocument/Edit",
    method: "post",
    data
  });
}
export function changeHostel(data) {
  return request({
    url: "/StudentDocument/ChangeHostel",
    method: "post",
    data
  });
}
export function debit(data) {
  return request({
    url: "/StudentDocument/DebitExtension",
    method: "post",
    data
  });
}
export function syncDPSISingle(data) {
  return request({
    url: "/StudentDocument/SyncDPSIForSingle",
    method: "post",
    data
  });
}

